import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    rowGap: 16,
  },
  uploadContainer: {
    width: 220,
    height: 180,
    border: '1px dashed #c4c1c1',
    borderRadius: 4,
  },
  error: {
    '& .MuiTypography-root': {
      color: theme.palette.error.main,
    },
  },
  caption: {
    '& .MuiTypography-root': {
      color: '#9a9a9a',
    },
  },
  imgWrapper: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
    paddingBlockEnd: 12,
  },
  imgContainer: {
    width: 220,
    height: 180,
    border: '1px solid #c4c1c1',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '&:hover': {
      '& $deleteIcon': {
        display: 'flex',
      },
    },
  },
  img: {
    width: '98%',
    height: '98%',
    objectFit: 'cover',
  },
  deleteIcon: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#453d3d9e',
    '& .MuiSvgIcon-root': {
      color: '#cb0a0a',
      cursor: 'pointer',
    },
  },
}))

export default useStyles
